import { NativeEventEmitter, NativeModules, Platform } from 'react-native';

// Inspect the installed bridge, never expoConfig.version (which an OTA replaces).
export function optionalMobileNativeModule(name, methods) {
  if (Platform.OS !== 'ios' && Platform.OS !== 'android') return null;
  const native = NativeModules[name];
  return methods.every(method => typeof native?.[method] === 'function') ? native : null;
}

export function optionalNativeEvent(native, event, listener) {
  if (typeof native?.addListener !== 'function' || typeof native?.removeListeners !== 'function') return null;
  try { return new NativeEventEmitter(native).addListener(event, listener); }
  catch { return null; }
}

export function hasExpoNativeModules(names) {
  if (Platform.OS !== 'ios' && Platform.OS !== 'android') return false;
  try {
    const { requireOptionalNativeModule } = require('expo');
    return names.every(name => Boolean(requireOptionalNativeModule(name)));
  } catch {
    return false;
  }
}
